
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/messages",
      function () {
        return require("private-next-pages/dashboard/messages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/messages"])
      });
    }
  